// extracted by mini-css-extract-plugin
export default {"Table":"Table7s1xUBJ2MRC4","Table-Add":"Table-Add1EC7WnIV3o4s"};